import React from 'react';
import Markdown from 'markdown-to-jsx';
import { Box } from '@mui/material';

interface ChatMarkdownProps {
  text: string;
  invert?: boolean;
}

const ChatMarkdown: React.FC<ChatMarkdownProps> = ({ text, invert = false }) => {
  const border = invert ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.12)';
  const headerBg = invert ? 'rgba(255,255,255,0.12)' : '#f3f4f6';

  return (
    <Box
      sx={{
        fontSize: '0.875rem',
        lineHeight: 1.5,
        '& p': { m: 0, mb: 1 },
        '& p:last-child': { mb: 0 },
        '& h1, & h2, & h3, & h4': {
          fontSize: '0.95rem',
          fontWeight: 600,
          mt: 1.25,
          mb: 0.75,
        },
        '& ul, & ol': { m: 0, mb: 1, pl: 2.5 },
        '& li': { mb: 0.25 },
        '& code': {
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          fontSize: '0.8em',
        },
        '& table': {
          borderCollapse: 'collapse',
          width: 'max-content',
          minWidth: '100%',
          fontSize: '0.8rem',
          my: 1,
        },
        '& th, & td': {
          border: `1px solid ${border}`,
          px: 1,
          py: 0.6,
          textAlign: 'left',
          whiteSpace: 'nowrap',
        },
        '& th': {
          bgcolor: headerBg,
          fontWeight: 600,
        },
      }}
    >
      <Markdown options={{ forceBlock: true }}>{text || ''}</Markdown>
    </Box>
  );
};

export default ChatMarkdown;
